var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-storage-deadline-modal"},[_c('b-modal',{ref:"modal",attrs:{"id":"storage-deadline-modal","size":"lg","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"py-3"},[_c('StorageDeadlineNotice',{on:{"continue-clicked":_vm.handleContinueClicked}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }